import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { EvaluationQueryParams, EvaluationTemplate } from '../models/evaluation.model';
import { ListResponse } from '../models/utility.model';
import { EvaluationGateway } from '../usecases/evaluation.gateway';

@Injectable()
export class EvaluationService extends EvaluationGateway {
  constructor(private _http: HttpClient) {
    super();
  }

  listEvaluationTemplates(params: EvaluationQueryParams): Observable<ListResponse<EvaluationTemplate>> {
    return this._http.get<ListResponse<EvaluationTemplate>>('api/vgs/evaluation-templates', { params });
  }
}
